import store from "services/store";
import { v4 as uuid } from "uuid";
import ClusterTemplateActions from "./actions";
import { CLUSTER_TEMPLATE_MODES } from "utils/constants";
import { createSelector } from "reselect";
import { PolicySchema } from "utils/schemas";
import { formatLinkedProfiles } from "./selectors";
import { getEntity } from "utils/entities";

export default class ClusterTemplateModule {
  constructor({
    name = uuid(),
    mode = CLUSTER_TEMPLATE_MODES.CREATE,
    maintenancePolicySubmit,
  } = {}) {
    this.guid = name;
    this.mode = mode;
    this.actions = new ClusterTemplateActions({
      guid: this.guid,
      maintenancePolicySubmit,
    });
  }

  get state() {
    return store.getState().clusterTemplateModule?.[this.guid];
  }

  selectors = {
    getRawMaintenancePolicy: getEntity(
      (state) => state.clusterTemplateModule[this.guid]?.maintenancePolicy,
      PolicySchema
    ),
    getFormattedLinkedProfiles: createSelector(
      (state) => state.clusterTemplateModule[this.guid]?.linkedProfiles,
      (profiles) => formatLinkedProfiles(profiles)
    ),
  };
}
